import { useMutation } from '@frontend/react-query-helpers';
import { UnlockProvisioning } from './api';
import { queryKeys } from './query-keys';
import type { UnlockProvisioningType } from './types';

export const useUnlockProvisioning = () => {
  return useMutation({
    mutationKey: queryKeys.unlockProvisioning(),
    mutationFn: (req: UnlockProvisioningType['input']) =>
      UnlockProvisioning({
        deviceIds: req.deviceIds,
      }),
  });
};
